import { useMemo } from 'react';
import { ChatModuleType } from 'app/copied/models/ChatModules';

import useModule from './useModule';
import { useOfflineModulesAvailable } from './useOfflineModulesAvailable';
import useFetchHelpCenter from './fetch/useFetchHelpCenter';

export interface RouteDeterminationOptions {
  allowNull?: boolean;
  checkRedirectConstraints?: boolean;
  persistedLocation?: string | null;
  tailorUrl?: string | null;
}

export function useRouteDetermination(options: RouteDeterminationOptions = {}): string | null {
  const { allowNull = false, checkRedirectConstraints = false, persistedLocation, tailorUrl } = options;
  const { data: helpCenter } = useFetchHelpCenter();
  const offlineModulesAvailable = useOfflineModulesAvailable();
  const vaModule = useModule(ChatModuleType.VirtualAssistant);
  const liveChatModule = useModule(ChatModuleType.LiveChat);

  return useMemo(() => {
    if (!helpCenter) {
      return allowNull ? null : '/tailor';
    }

    if (vaModule?.va_as_landing_page_enabled) {
      return '/virtual-assistant';
    }

    if (liveChatModule && !offlineModulesAvailable) {
      return '/live-chat';
    }

    if (offlineModulesAvailable) {
      if (allowNull && checkRedirectConstraints && (persistedLocation || tailorUrl)) {
        return null;
      }
      return '/tailor';
    }

    return '/tailor';
  }, [
    helpCenter,
    vaModule,
    offlineModulesAvailable,
    liveChatModule,
    allowNull,
    checkRedirectConstraints,
    persistedLocation,
    tailorUrl,
  ]);
}
